const tableScroll = () => {
  const tables = document.querySelectorAll('.table-block02');

  if (tables.length === 0) return;

  tables.forEach(table => {
    const icon = table.querySelector('.scroll-icon');

    table.addEventListener('touchstart', () => {
      icon.style.opacity = 0;
      console.log('start');
    });
    table.addEventListener('touchend', () => {
      icon.style.opacity = 1;
      console.log('end');
    });
  });

};

const init = () => {
  tableScroll();
};

export default init;
